<template>
    <div
            class="sorting-icon d-flex flex-column ml-auto"
            @click="changeOrder"
    >
        <i
                class="arrow far fa-sort-alt text-gray-700"
                v-if="!getSortFieldValue()"
        ></i>
        <i
                class="arrow-up arrow far fa-long-arrow-up text-gray-700"
                :class="getCssClass('asc')"
        />
        <i
                class="arrow-down arrow far fa-long-arrow-down text-gray-700"
                :class="getCssClass('desc')"
        />
    </div>
</template>

<script>
    import './SortColumn.scss';
    import set from 'lodash/set';
    import get from 'lodash/get';

    export default {
        name: 'SortColumn',
        layout: 'default',

        props: {
            sortField: {
                type: String,
                required: true,
            },
            orderBy: {
                type: Object,
                default: () => {
                },
            },
        },
        data() {
            return {
                clicks: 0,
                timer: null,
                optionIndex: 0,
                options: ['default', 'asc', 'desc'],
            };
        },

        computed: {
            orderedBy() {
                return this.orderBy;
            },
        },

        methods: {
            changeOrder() {
                let sortFieldValue = get(this.orderedBy, this.sortField);

                let orderBy = {};
                if (!sortFieldValue || sortFieldValue === 'desc') {
                    set(orderBy, this.sortField, this.options[1]);
                } else if (sortFieldValue === 'asc') {
                    set(orderBy, this.sortField, this.options[2]);
                }

                this.$forceUpdate();
                this.$emit('changeSortDirection', orderBy, this.sortField);
            },

            getSortFieldValue() {
                return get(this.orderedBy, this.sortField) || false;
            },

            getCssClass(order) {
                const cssClasses = [];
                let sortFieldValue = this.getSortFieldValue();

                if (sortFieldValue && sortFieldValue === order) {
                    cssClasses.push('active');
                }

                if (sortFieldValue !== order) {
                    cssClasses.push('hidden');
                }

                return cssClasses;
            },
        },
    };
</script>
